module.exports = __webpack_public_path__ + "img/air.cbf39e86.png";